import React, { useState, useEffect } from "react";
import { CDBBtn } from 'cdbreact';
import Select from "react-select";
import { format } from "mathjs";

export const ModalQualitys = ({
  action,
  setPressedButton,
  formData,
  handleChange,
  receptions,
  setFormData,
}) => {

  if (receptions === undefined) {
    receptions = []
  }

  const receptionsSelect = receptions.map((reception) => ({
    value: `${reception.LotNumber}/*-/${reception.CodeSap}/*-/${reception.Nit}`,
    label: `Lote: ${reception.LotNumber} / Código SAP: ${reception.CodeSap} / Código Proveedor: ${reception.Nit}`,
  }));
    
  return (
    <div>
      <div className="modal-header">
        <div>
          <h3 className="modal-title" id="exampleModalLabel">
            {action === 'create' ? 'Crear' : 'Editando un registro'}
          </h3>
        </div>
        {action === 'edit' ? (
          <CDBBtn
            size="small"
            className="p-2 btn"
            color="danger"
            outline
            onClick={() => {
              setPressedButton('delete');
            }}
          >
            <i className="fas fa-trash"></i>
            Eliminar
          </CDBBtn>
        ) : null}
      </div>
      <div className="modal-body">
        <div className="form-group row mb-4">
          <div className="col">
            <label htmlFor="lotNumber">Número del lote:</label>
            <Select
              id="LotNumber"
              placeholder="Seleccione un lote"
              isDisabled={action === 'edit'}
              options={receptionsSelect}
              value={receptionsSelect.find((option) => option.value === `${formData.LotNumber}/*-/${formData.CodeSap}/*-/${formData.Nit}`)}
              onChange={(selectedOption) => {
                const { value } = selectedOption;
                
                const selectedReceptionData = receptions.find(reception => reception.LotNumber === value.split("/*-/")[0] 
                && reception.CodeSap === value.split("/*-/")[1]
                && reception.Nit === value.split("/*-/")[2]);

                handleChange([
                  { id: "CodeSap", value: selectedReceptionData.CodeSap },
                  { id: "LotNumber", value: selectedReceptionData.LotNumber },
                  { id: "Nit", value: selectedReceptionData.Nit },
                  { id: "UnitsQualitysReception", value: selectedReceptionData.UnitsReception - selectedReceptionData.UnitsDefective },
                ]);
              }}
            />
          </div>
        </div>
        <div className="form-group">
            <label>Código SAP:</label>
            <input
              type="text"
              className="form-control mb-4"
              id="CodeSap"
              placeholder="Código SAP"
              disabled
              value={formData.CodeSap}
              onChange={handleChange}
            />
        </div>
        <div className="form-group">
          <label>Unidades recibidas verificadas:</label>
            <input
              type="text"
              className="form-control mb-4"
              id="UnitsQualitysReception"
              placeholder="Unidades recibidas"
              disabled
              value={formData.UnitsQualitysReception}
              onChange={handleChange}
            />
        </div>
        <div className="form-group">
          <label htmlFor="Rop">Unidades dañadas:<span className="text-danger"> *</span></label>
          <input
            type="number"
            className="form-control mb-4"
            id="UnitsQualitysDefective"
            placeholder="Unidades dañadas después del proceso"
            value={formData.UnitsQualitysDefective}
            onChange={(e) =>
              handleChange([
                { id: "UnitsQualitysDefective", value: e.target.value }
              ])
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="SkuDescription">Descripción:<span className="text-danger"> *</span></label>
          <textarea
            className="form-control mb-4"
            id="ReceptionsDescription"
            placeholder="Descripción de la recepción"
            value={formData.ReceptionsDescription}
            onChange={(e) =>
              handleChange([
                { id: "ReceptionsDescription", value: e.target.value }
              ])
            }
          />
        </div>
      </div>
      <div className="modal-footer justify-content-center align-items-center">
        <CDBBtn
          type="button"
          color="danger"
          outline
          onClick={() => setPressedButton('closeModal')}
        >
          Cerrar
        </CDBBtn>
        <CDBBtn
          type="button"
          color="success"
          className="mr-auto"
          outline
          onClick={() => setPressedButton('submitModal')}
        >
          Guardar
        </CDBBtn>
      </div>
    </div>
  );
};